import React, { Component } from 'react'
import {
    Row, Col, Alert, Progress, Label, Button, FormGroup, Input, Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap'
import collectionsListCharge from "../graphql/collectionsListCharge"
import { COLLECTION_DAYS } from "../Constants"
import withApolloClient from '../withApolloClient'
import Select from "react-select"
import moment from 'moment'
import './RepAssignmentModal.css'

class WeeklyChargeModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            error: null,
            chargeSuccess: false,
            chargeDueDate: moment().tz("America/New_York").format("YYYY-MM-DD"),
            billingCode: "",
            branches: [],
            collectionDay: COLLECTION_DAYS.map(day => ({ value: day.pyValue, label: day.name })).find(day => ((new Date()).getDay() + 6) % 7 === day.value)
        }
    }

    updateInput = (e) => {
        let name = e.target.name
        let value = e.target.value
        this.setState({ [name]: value })
    };

    chargeDrivers = () => {
        try {
            const { collectionDay, chargeDueDate, billingCode, branches } = this.state
            if (collectionDay?.value === undefined || !chargeDueDate || !billingCode) {
                this.setState({ error: "Please complete all required fields." })
                return
            }

            this.setState({ loading: true })
            let input = {
                billingCode: billingCode,
                dueDate: chargeDueDate,
            }
            if (this.props.selectedDrivers && this.props.selectedDrivers.length > 0) {
                input["driverIds"] = this.props.selectedDrivers
            } else {
                input["branchIds"] = branches.map(branch => branch.value)
                input["collectionDay"] = collectionDay.value
            }
            this.props.apolloClient.mutate({
                mutation: collectionsListCharge,
                variables: { input },
            }).then((result) => {
                if (result.data && result.data.collectionsListCharge && result.data.collectionsListCharge.ok) {
                    this.setState({ loading: false, chargeSuccess: true, error: null })
                } else {
                    let error = "An error has occured. Please contact system admin"
                    if (result.data && result.data.collectionsListCharge && result.data.collectionsListCharge.errors && result.data.collectionsListCharge.errors[0] && result.data.collectionsListCharge.errors[0].messages) {
                        error = result.data.collectionsListCharge.errors[0].messages[0]
                    }
                    this.setState({ loading: false, chargeSuccess: false, error: error })
                }
            }).catch((error) => {
                let errorMessage = "An error has occured"
                this.setState({ error: errorMessage, loading: false, chargeSuccess: false, })
            })
        } catch (err) {
            let errorMessage = "An error has occured"
            this.setState({ error: errorMessage, loading: false, chargeSuccess: false, })
        }
    };

    componentDidMount() {
        if (this.props.currentUser && (!this.state.branches || this.state.branches.length === 0)) {
            let branchNamesIds = this.props.currentUser?.member?.branches?.edges.map(({ node }) => ({ value: node.id, label: node.name })) || []
            this.setState({ branches: branchNamesIds })
        }
    }

    render() {
        let branchNamesIds = this.props.currentUser?.member?.branches?.edges.map(({ node }) => ({ value: node.id, label: node.name })) || []
        return (
            <div>
                <Modal className="weeklyChargeModal modal-dialog-centered" isOpen={this.props.open}>
                    <ModalHeader style={{ "justifyContent": "center" }}>
                        {this.props.title ? this.props.title : "Charge Weekly Rent for " + (this.state.collectionDay?.label || "") + " Customers"}
                    </ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col xs={12}>
                                {this.props.selectedDrivers?.length > 0 && <p style={{ fontSize: "1.2rem", color: "green" }}>{this.props.selectedDrivers.length} customers selected to be charged!</p>}
                            </Col>
                            {this.state.error &&
                                <Col xs={12}>
                                    <Alert color="danger">{this.state.error}</Alert>
                                </Col>
                            }
                            {this.state.chargeSuccess ?
                                <Col xs={12}>
                                    <Alert color="success">Weekly charge started successfully! You will be notified once this process is complete.</Alert>
                                </Col> :
                                <>
                                    <Col xs={12}>
                                        <FormGroup>
                                            <Label className="mb-0" for="billingCode">Billing Code</Label>
                                            <small className="form-text text-muted mb-2 mt-0">
                                                Authorized code for processing charges.
                                            </small>
                                            <Input type="text" name="billingCode" id="billingCode" onChange={this.updateInput} placeholder="Enter billing code" />
                                        </FormGroup>
                                    </Col>
                                    <Col xs={12}>
                                        <FormGroup>
                                            <Label className="mb-0" for="chargeDueDate">Due Date</Label>
                                            <small className="form-text text-muted mb-2 mt-0">
                                                Cut-off date for customer balance calculation.
                                            </small>
                                            <Input
                                                type="date"
                                                name="chargeDueDate"
                                                id="chargeDueDate"
                                                onChange={this.updateInput}
                                                value={this.state.chargeDueDate}
                                                placeholder="Due Date"
                                            />
                                        </FormGroup>
                                    </Col>
                                    {(!this.props.selectedDrivers || this.props.selectedDrivers.length === 0) ? <>
                                        <Col xs={12}>
                                            <FormGroup>
                                                <Label className="mb-0" for="collectionDay">Collection Day</Label>
                                                <small className="form-text text-muted mb-2 mt-0">
                                                    Customers having this collection day will be charged.
                                                </small>
                                                <Select
                                                    name="collectionDay"
                                                    value={this.state.collectionDay}
                                                    options={COLLECTION_DAYS.map(day => ({ value: day.pyValue, label: day.name })) || []}
                                                    className="basic-multi-select"
                                                    classNamePrefix="select"
                                                    onChange={(selectedOption) => this.setState({ collectionDay: selectedOption })}
                                                />
                                            </FormGroup>
                                        </Col>
                                        {branchNamesIds && branchNamesIds.length > 0 &&
                                            <Col xs={12}>
                                                <FormGroup>
                                                    <Label className="mb-0" for="branch">Branches</Label>
                                                    <small className="form-text text-muted mb-2 mt-0">
                                                        Branches to include in this run.
                                                    </small>
                                                    <Select
                                                        isMulti
                                                        name="branches"
                                                        value={this.state.branches}
                                                        options={branchNamesIds}
                                                        className="basic-multi-select"
                                                        classNamePrefix="select"
                                                        onChange={(selectedOption) => this.setState({ branches: selectedOption })}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        }
                                        <Col xs={12}>
                                            <Alert color="info">
                                                Note: Only customers with an <b>active agreement</b>, <b>visible in collections</b>, and with <b>Auto-Charge enabled</b> at both the branch and profile level will be processed. Customers who already have <b>scheduled payments</b> will not be included.
                                            </Alert>
                                        </Col>

                                    </> : <Col xs={12}>
                                        <Alert color="info">
                                            Note: Customers who already have <b>scheduled payments</b> will not be included.
                                        </Alert>
                                    </Col>}
                                </>
                            }
                            <a ref={el => this.downloadLink = el} target="_blank" >&nbsp;</a>
                        </Row>
                        {this.state.loading && <Row><Col xs={12}><Progress animated color="info" value="100" /></Col></Row>}
                    </ModalBody>
                    <ModalFooter>
                        {!this.state.loading &&
                            <Row>
                                <Col xs={12}>
                                    <Button outline color="secondary" onClick={this.props.handleClose}>Close</Button>&nbsp;&nbsp;
                                    <Button color="secondary" onClick={() => this.chargeDrivers()}
                                        disabled={
                                            !this.state.chargeDueDate ||
                                            !this.state.billingCode ||
                                            this.state.collectionDay?.value === undefined ||
                                            this.state.chargeSuccess ||
                                            this.state.loading
                                        }>Charge Customers</Button>
                                </Col>
                            </Row>
                        }
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}

export default (withApolloClient(WeeklyChargeModal))
